export const openLiveTest = () => {
  window.dispatchEvent(new CustomEvent("open-live-test"));
};

// Opens the real live-call console (the SIP CallOrb mounted by LiveCallDemo). LiveCallDemo owns
// the SIP client + config, so it listens for this event and decides what to do — start the call
// when SIP is configured, or scroll the hero orb into view (its "coming soon" state) when it isn't.
export const openLiveCall = () => {
  window.dispatchEvent(new CustomEvent("open-live-call"));
};
